/* istanbul ignore file -- not testable as it's lazy loaded */
import { useToken } from '@ori/auth';
import { useServiceUrls } from '@ori/configuration-manager';
import type { PersonalMenuProps } from '@ori/personal-menu';
import { lazy, useMemo } from 'react';

import { useAppConfig, useConsultant } from '../context';

const LazyPersonalMenu = lazy(async () => ({
  default: (await import('@ori/personal-menu')).PersonalMenu,
}));

export const useLazyPersonalMenu = () => {
  const { customerId, token } = useToken();
  const { currentLanguage, personalMenuInitialData, reportsItemName, tenant } = useAppConfig();
  const { globalApiUrl, mobileOfficeApiUrl, staticApiUrl } = useServiceUrls([
    'globalApi',
    'mobileOfficeApi',
    'staticApi',
  ]);
  const { consultantNumber, consultantType } = useConsultant();
  const configuration = useMemo<PersonalMenuProps['configuration']>(
    () => ({
      consultantNumber,
      consultantType,
      customerId,
      globalApiUrl,
      lang: currentLanguage,
      mobileOfficeApiUrl,
      personalMenuInitialData,
      reportsItemName,
      staticApiUrl,
      tenant,
      token,
    }),
    [
      consultantNumber,
      consultantType,
      currentLanguage,
      customerId,
      globalApiUrl,
      mobileOfficeApiUrl,
      personalMenuInitialData,
      reportsItemName,
      staticApiUrl,
      tenant,
      token,
    ],
  );

  return <LazyPersonalMenu configuration={configuration} />;
};
